import React, { Component } from 'react'
import PropTypes from 'prop-types'

/**
 * Basic component for rendering a link
 */
export default class ALink extends Component {
  /**
   * Render component
   */
  render () {
    const tar = this.props.noNewTab ? '' : '_blank'

    return (
      <span>
        {' '}
        <a href={this.props.href} target={tar} rel='noopener noreferrer'>
          {this.props.children}
        </a>{' '}
      </span>
    )
  }
}

ALink.propTypes = {
  noNewTab: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/sections/ALink.js